<template>
  <div :class="{ column: column }" class="content-chips-list">
    <div
      v-for="(chip, chipIndex) in chips"
      :key="chipIndex"
      class="content-chips-list_item-container"
      :class="{
        clickable: clickable,
        [`${chip.color}`]: chip.color,
        'medium-blue': chip.color === 'medium-blue',
      }"
      @click="systemClassClick(chip)"
    >
      <i
        v-if="chip.leadingIcon"
        class="content-chips-list_item-thumbnail"
        :class="chip.leadingIcon"
      />
      <img v-if="chip.icon" :src="chip.icon" alt="" class="content-chips-list_item-leadingImg" />
      <p class="content-chips-list_item-text" :class="{ bold: chip.bold }">
        {{ $_getLocale(chip, 'name') }}
      </p>
      <router-link v-if="to" :to="`${to}${chip.id}`" class="content-chips-list_item-router" />
    </div>
  </div>
</template>

<script>
import H_common from '@/helpers/common';

export default {
  name: 'ContentChipsList',
  props: {
    chips: {
      type: Array,
      default() {
        return [];
      },
    },
    column: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: '',
    },
  },
  data: () => ({}),
  methods: {
    systemClassClick(chip) {
      this.$emit('system-click', chip.id);
    },
    $_getLocale(object, textKey) {
      return H_common.getLocale(object, textKey);
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/component/content-chips-list';
</style>
